/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { computed, reactive } from "vue"
import { navigationState } from "@/domain/navigation/navigation.state"

/*
|--------------------------------------------------------------------------
| Badge Store
|--------------------------------------------------------------------------
| Zentraler Badge State für Navigation
|
| Kann später ersetzt werden durch:
| - API Polling
| - Websocket Updates
| - Domain Events
*/

const navBadges = reactive({
    activity: 3,
    systemIssues: 1,
    overdueInvoices: 2,
    logWarnings: 5
})

/*
|--------------------------------------------------------------------------
| Navigation UI Adapter
|--------------------------------------------------------------------------
*/

export function useNavigationUI() {

    /*
    |--------------------------------------------------------------------------
    | Navigation Structure
    |--------------------------------------------------------------------------
    */

    const visibleNav = computed(() => {
        return navigationState.structure ?? []
    })


    /*
    |--------------------------------------------------------------------------
    | Badge Helpers
    |--------------------------------------------------------------------------
    */

    function getBadge(key) {
        if (!key) return null
        return navBadges[key] ?? null
    }

    function setBadge(key, value) {
        if (!key) return
        navBadges[key] = value
    }

    function clearBadge(key) {
        if (!key) return
        navBadges[key] = 0
    }


    /*
    |--------------------------------------------------------------------------
    | Section Helpers
    |--------------------------------------------------------------------------
    */

    function hasSectionNotification(section) {

        if (!section?.children?.length) {
            return false
        }

        return section.children.some(child => {
            if (!child.badgeKey) return false
            return (navBadges[child.badgeKey] ?? 0) > 0
        })
    }


    /*
    |--------------------------------------------------------------------------
    | Public API
    |--------------------------------------------------------------------------
    */

    return {
        visibleNav,
        navBadges,

        getBadge,
        setBadge,
        clearBadge,

        hasSectionNotification
    }

}